import { useEffect, useRef } from 'react';
import { bootstrapAuthSession, logout as authLogout } from '../services/authService';
import { getStoredRefreshToken, setStoredTokens, setStoredUser } from '../services/apiClient';

/**
 * Sekme tekrar görünür olduğunda oturumu sunucuda doğrular.
 * @param {{ enabled?: boolean, onSessionInvalid?: () => void }} options
 */
export function useSessionGuard({ enabled = true, onSessionInvalid } = {}) {
  const checkingRef = useRef(false);

  useEffect(() => {
    if (!enabled || typeof document === 'undefined') return undefined;

    const verify = async () => {
      if (checkingRef.current) return;
      if (!getStoredRefreshToken()) return;

      checkingRef.current = true;
      try {
        const profile = await bootstrapAuthSession();
        const k = profile?.veri?.kullanici || profile?.kullanici;
        if (k) setStoredUser(k);
      } catch (error) {
        if (error?.status === 429) {
          return;
        }
        setStoredTokens({ token: null, refreshToken: null, sessionId: null });
        setStoredUser(null);
        try {
          await authLogout();
        } catch {
          /* ignore */
        }
        onSessionInvalid?.();
      } finally {
        checkingRef.current = false;
      }
    };

    const onVisibility = () => {
      if (document.visibilityState === 'visible') {
        verify();
      }
    };

    document.addEventListener('visibilitychange', onVisibility);
    return () => document.removeEventListener('visibilitychange', onVisibility);
  }, [enabled, onSessionInvalid]);
}
